import axios from 'axios';

export const search = async (content, type) => {

    const response = await axios.put(`${process.env.REACT_APP_AWS_URL}/api/search`, { content, type })

    return response.data

}